module.exports = __webpack_public_path__ + "static/media/compras.f591430d.svg";